<!-- filepath: /Users/jaminmeyers/Documents/Websites/choicesocial.us/src/components/EmojiPopover.vue -->
<template>
    <div class="emoji-popover">
      <div class="emoji-grid">
        <span
          v-for="(emoji, index) in emojis"
          :key="index"
          class="emoji"
          @click="selectEmoji(emoji)"
        >
          {{ emoji }}
        </span>
      </div>
    </div>
  </template>
  
  <script>
  import { popoverController } from "@ionic/vue";


  export default {
    name: "EmojiPopover",
    data() {
      return {
        emojis: [
          "😀", "😂", "😍", "😎", "😢", "😡", "👍", "👎", "🎉", "❤️", "🔥", "💯", "👏", "🙏", "🎶", "🎁",
        ], // Add more emojis as needed
      };
    },
    methods: {
      selectEmoji(emoji) {
        popoverController.dismiss(emoji, null);
        //this.$emit("emoji-selected", emoji); // Emit the selected emoji to the parent
        //this.closePopover();
      },
      async closePopover() {
        popoverController.dismiss();
      },
    },
  };
  </script>
  
  <style scoped>
  .emoji-popover {
    padding: 10px;
    text-align: center;
  }
  
  .emoji-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* Adjust the number of columns */
    gap: 10px;
  }
  
  .emoji {
    font-size: 24px;
    cursor: pointer;
    transition: transform 0.2s;
  }
  
  .emoji:hover {
    transform: scale(1.2);
  }
  </style>